// 资料
const bbsData = {
  path: '/data',
  name: 'Data',
  component: () => import('@/views/bbsData/index')
}
export default bbsData

